import React, {useState, useEffect, useCallback, useRef } from 'react';
import config from '../../../app/config';
import UserAvatarIcon from './UserAvatarIcon';

import {
  AlignCenter,
  User,
  LogOut,
  Maximize,
  MoreHorizontal,
  Moon,
  Sun
} from 'react-feather';
import AppLink from '../AppLink';

import {HasRole} from 'react-role-permission'

const Header = ({ mode = "fixed" }) => {

  const [searchValue, setsearchValue] = useState('');
  const [navmenu, setNavmenu] = useState(false)
  const [sidebar, setSidebar] = useState("iconsidebar-menu");
  const [rightSidebar, setRightSidebar] = useState(true);
  const [themme, setTheme] = useState(localStorage.getItem('theme') ? localStorage.getItem('theme') : 'light');
  const headerRef = useRef(null);

  const escFunction = useCallback((event) => {
    if (event.keyCode === 27) {
      setsearchValue('')
    }
  }, []);

  useEffect(() => {
    function updateHeaderSize() {
      if (headerRef.current) {
        const size = headerRef.current.offsetHeight + "px";
        console.log(`Update size: ${size}`);
        document.documentElement.style.setProperty("--header-size", size);
      }
    }
    updateHeaderSize();
    window.addEventListener("resize", updateHeaderSize);
    window.addEventListener("load", updateHeaderSize);
    return () => {
      window.removeEventListener("load", updateHeaderSize);
      window.removeEventListener("resize", updateHeaderSize);
    };
  }, []);

  useEffect(() => {

    document.addEventListener("keydown", escFunction, false);
    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, [escFunction]);

  function goBack() {
    window.history.go(-1);
  }

  const openCloseSidebar = (sidebartoggle) => {
    if (sidebartoggle === "iconsidebar-menu") {
      setSidebar("iconbar-mainmenu-close");
      document.querySelector(".iconsidebar-menu").classList.add('iconbar-mainmenu-close');
    } else if (sidebartoggle === "iconbar-mainmenu-close") {
      setSidebar("iconbar-second-close");
      document.querySelector(".iconsidebar-menu").classList.add('iconbar-second-close');
      document.querySelector(".iconsidebar-menu").classList.remove('iconbar-mainmenu-close');
    } else {
      setSidebar("iconsidebar-menu");
      document.querySelector(".iconsidebar-menu").classList.remove('iconbar-second-close');
    }
  }


  //full screen function
  const goFull = () => {
    if (document.fullScreenElement ||
      (!document.mozFullScreen && !document.webkitIsFullScreen)) {
      if (document.documentElement.requestFullScreen) {
        document.documentElement.requestFullScreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullScreen) {
        document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  const switchTheme = () => {
    console.log(1);
    if (localStorage.getItem('theme') === 'dark') {
      localStorage.setItem('theme', 'light');

      localStorage.setItem("layout_version", "light");
      document.body.classList.remove('dark-only');
      document.body.classList.add('light');
      setTheme('light');
    } else {
      localStorage.setItem('theme', 'dark');
      localStorage.setItem("layout_version", "dark-only");
      document.body.classList.remove('light');
      document.body.classList.add('dark-only');


      setTheme('dark');
    }
  };

  const logOut = () => {
    localStorage.removeItem("profileURL");
    localStorage.removeItem('session_token');
    localStorage.removeItem('session_expire');
    //app.auth().signOut();
    window.location.href = `${process.env.PUBLIC_URL}/login`;
  };

  const Navmenuhideandshow = () => {
    if (navmenu) {
      setNavmenu(!navmenu)
      document.querySelector('.nav-menus').classList.add('open')
    } else {
      setNavmenu(!navmenu)
      document.querySelector('.nav-menus').classList.remove('open')
    }
  };

  const appTitle = config.title;
  const appSlugline = config.slugline;

  return (
    <div ref={headerRef} className={`page-main-header flex items-center justify-between header--${mode}`}>
      <div className="mobile-sidebar">
        {(localStorage.getItem('id') && (HasRole('admin') || HasRole('group_admin') || HasRole('group_user'))) ? (
          <label className="switch ml-3"><AlignCenter className="font-primary"
            onClick={() => openCloseSidebar(sidebar)} /></label>)
          : (window.location.href.indexOf('portal') === -1) ? <label className="switch ml-3">
            <i className="icofont icofont-rounded-double-left font-primary"
              style={{ fontSize: '24px', cursor: 'pointer' }} onClick={goBack} /></label> : ''}
      </div>
      <div className="main-header-left items-center">
        <div className="logo-wrapper"><AppLink
          to={(localStorage.getItem('id') && (HasRole('admin') || HasRole('group_admin') || HasRole('group_user'))) ? "/dashboard/default" : '/portal'}><img
            src="/images/logo.png" alt="" /></AppLink></div>
      </div>
      <div className="main-header-center items-center ml-4">
        {appTitle && (
          <h1
            className={`text-xl font-bold mb-1 ${themme === "light" ? "font-primary" : "text-light"
              }`}
          >
            {appTitle}
          </h1>
        )}
        {appSlugline && (
          <p
            className={`text-base leading-tight ${themme === "light" ? "font-primary" : "text-light"
              }`}
          >
            {appSlugline}
          </p>
        )}
      </div>
      <div className="main-header-right gap-4 ml-auto">
        <div className="nav-right col pull-right right-menu">
          <ul className="nav-menus">
      <li><a className="pull-right text-dark" href="#javascript!" onClick={goFull}><Maximize style={{ stroke: 'var(--primary-color)' }} /></a></li>
     {/* <li><a className="pull-right text-dark" href="#javascript!" onClick={switchTheme}>{(themme === 'light') ? <Moon style={{ stroke: 'var(--primary-color)' }} /> : <Sun style={{ stroke: "yellow", fill: "yellow !important" }} />}</a></li> */}
            <li className="onhover-dropdown"><span className="media user-header"><UserAvatarIcon /></span>
              <ul className="onhover-show-div profile-dropdown">
                <li className="gradient-primary">
                  <h5
                    className="f-w-600 mb-0">{(localStorage.getItem('id') && (HasRole('admin') || HasRole('group_admin') || HasRole('group_user'))) ? localStorage.getItem("Name") : 'Guest'}</h5>
                  <span>{HasRole('admin') ? 'Admin' : HasRole('group_user') ? 'User' : HasRole('group_admin') ? 'Group Admin' : 'Guest'}</span>
                </li>
                <li>{(localStorage.getItem('id') && (HasRole('admin') || HasRole('group_admin') || HasRole('group_user'))) ? (
                  <AppLink to={'/profilo?id=' + localStorage.getItem('id')}><User />Profile</AppLink>) : (
                  <AppLink to={'/login'}><User />Area Riservata</AppLink>)}</li>
                {(localStorage.getItem('id') && (HasRole('admin') || HasRole('group_admin') || HasRole('group_user'))) ?
                  <li onClick={logOut}><LogOut />Logout</li> : ''}
              </ul>
            </li>
          </ul>
          <div className="d-lg-none mobile-toggle pull-right" onClick={Navmenuhideandshow}><MoreHorizontal /></div>
        </div>

      </div>
    </div>
  );
}

export default Header;
